import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useDevice } from '../context/DeviceContext';
import { LoadingDisplay } from './utils';

export const HotspotSettingsTab = () => {
    const { device, api } = useDevice();
    const { register, handleSubmit, reset, formState: { isSubmitting, isDirty } } = useForm();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!device || !api) {
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        api.getDefaultProfileRate(device.id)
            .then(data => {
                reset(data);
            })
            .catch(err => toast.error("Failed to load current rate limit."))
            .finally(() => setIsLoading(false));
    }, [device, api, reset]);

    const onSubmit = async (data) => {
        const rates = {
            rxRate: parseFloat(data.rxRate),
            txRate: parseFloat(data.txRate)
        };
        await toast.promise(
            api.updateDefaultProfileRate(device.id, rates),
            {
                loading: 'Updating rate limit...',
                success: 'Rate limit updated successfully!',
                error: (err) => err.response?.data?.message || 'Failed to update rate limit.'
            }
        );
        reset(data);
    };
    
    if (isLoading) {
         return <LoadingDisplay message="Loading Hotspot Settings..." />;
    }

    return (
        <div className="text-gray-800">
            <h2 className="text-xl font-semibold mb-6">Default Hotspot Profile Settings</h2>
            <div className="max-w-md bg-gray-50 p-6 rounded-lg shadow-inner">
                <p className="text-sm text-gray-600 mb-4">Set the default upload (RX) and download (TX) speed for newly created hotspot users.</p>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="mb-4">
                        <label htmlFor="rxRate" className="block text-gray-700 text-sm font-bold mb-2">Default Upload Rate (Mbps)</label>
                        <input
                            id="rxRate"
                            type="number"
                            step="0.1"
                            min="0"
                            className="input-class w-full"
                            {...register('rxRate', { required: true, valueAsNumber: true })}
                        />
                    </div>
                    <div className="mb-6">
                        <label htmlFor="txRate" className="block text-gray-700 text-sm font-bold mb-2">Default Download Rate (Mbps)</label>
                         <input
                            id="txRate"
                            type="number"
                            step="0.1"
                            min="0"
                            className="input-class w-full"
                            {...register('txRate', { required: true, valueAsNumber: true })}
                        />
                    </div>
                    <button
                        type="submit"
                        className="w-full btn-primary"
                        disabled={isSubmitting || !isDirty}
                    >
                        {isSubmitting ? 'Saving...' : 'Save Changes'}
                    </button>
                </form>
            </div>
        </div>
    );
};